import React from 'react';

import { RefreshToken } from '@crossnokaye/typescript-sdk/models/components';
import { Label } from '@crossnokaye/ux-common';

import { RevokeTokenAction } from '@/features/tokens/components/actions/RevokeTokenAction';

interface EditTokenActionsProps {
  token: RefreshToken;
  closeDrawer: () => void;
}

export const EditTokenActions: React.FC<EditTokenActionsProps> = ({ token, closeDrawer }) => {
  return (
    <div className={'space-y-4'}>
      <div className={'flex flex-col space-y-4'}>
        <div className={'flex items-center justify-between p-4 bg-destructive/10 rounded-lg gap-8'}>
          <div className={'space-y-1'}>
            <Label className={'text-base text-destructive'}>{'Revoke Token'}</Label>
            <p className={'text-sm text-muted-foreground'}>
              {'This will remove the token and API requests with it will no longer work.'}
            </p>
          </div>
          <RevokeTokenAction
            token={token}
            size={'lg'}
            variant={'destructive'}
            onActionSuccess={closeDrawer}
          />
        </div>
      </div>
    </div>
  );
};
